module.exports = __webpack_public_path__ + "media/images/portugal_center/Rio_nabao-299f60b036aff7bf5738fa85d361c52e.jpg";